import { render, staticRenderFns } from "./CourseClasses.vue?vue&type=template&id=b937799a&"
import script from "./CourseClasses.vue?vue&type=script&lang=js&"
export * from "./CourseClasses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports